import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as io from 'socket.io-client'

import { environment } from "../../../environments/environment"
import { AppService } from 'src/app/server/app.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/shared/security/auth.service';
//import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component'
export let isDebugMode = environment.isDebugMode

@Component({
  selector: 'flow-starter-content',
  templateUrl: './starter-content.component.html',
  styleUrls: ['./starter-content.component.scss']
})
export class StarterContentComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = []
  sessionForm: FormGroup
  themeid: number
  header: string
  detailOpened: boolean = false
  loggedIn: boolean
  modalOpened: boolean = false
  messages: any = []
  public msgAll: boolean = false;
  private socket: any
  //breadcrumb: string

  constructor(
    private appService: AppService,
    private fb: FormBuilder,
    private auth: AuthService
  ) {
    this.detailOpened = false
    this.appService.getPassport().subscribe(
      passport => {
        this.sessionForm.controls['groupid'].setValue(passport.groupid)
        this.sessionForm.controls['xgroupid'].setValue(passport.xgroupid)
        this.sessionForm.controls['themeid'].setValue(passport.themeid)
        this.sessionForm.controls['xthemeid'].setValue(passport.xthemeid)
        this.appService.eventSession.emit(this.appService.session)
      }
    )

    let urlsocket = `${environment.socketserver}`

    this.socket = io(urlsocket)

    this.socket.on("message",
      data => {
        if (!this.modalOpened) {
          this.messages = JSON.parse(data).filter(msg => { return msg.userid == this.appService.session.userid })
          if (this.messages.length > 0) {
            this.modalOpened = true;
          }
        }
      }
    )

    this.socket.on("progress",
      data => {
        // console.log(JSON.stringify(data))
        this.appService.progressTax = data
        this.appService.eventProgress.emit(data)
      }
    )




  }

  ngOnInit() {
    isDebugMode ? console.log(`ngOnInit()`) : undefined

    this.initForms()
    this.themeid = 1
    //this.breadcrumb = this.appService.breadcrumb

    this.subscriptions.push(

      this.appService.title.subscribe(val => this.header = val),

      this.auth.loggedInChange.subscribe(logged => {
        this.loggedIn = logged
      }),

      this.sessionForm.controls['themeid'].valueChanges.subscribe(val => {
        if (this.appService.session) {
          if (this.appService.session.themeid != val) {
            this.appService.session.themeid = val
            this.appService.eventSession.emit(this.appService.session)
            this.appService.setUser().subscribe(user => {
            })
          }
        }
      }),

      this.sessionForm.controls['groupid'].valueChanges.subscribe(val => {
        if (this.appService.session.groupid != val) {
          this.appService.session.groupid = val
          this.appService.eventSession.emit(this.appService.session)
          this.appService.setUser().subscribe(user => {
            console.log(user)
          })
        }
      }),

      this.appService.eventOpenDetail.subscribe(val => {
        setTimeout(() => {
          this.detailOpened = val
        }, 10)
      })

    )

  }

  ngAfterViewInit() {
    isDebugMode ? console.log(`ngAfterViewInit()`) : undefined
    this.loadForms()
  }

  ngOnDestroy() {
    isDebugMode ? console.log(`ngOnDestroy()`) : undefined
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }

  initForms() {
    isDebugMode ? console.log(`initForms()`) : undefined
    this.sessionForm = this.fb.group({
      themeid: this.fb.control(""),
      xthemeid: this.fb.control(""),
      groupid: this.fb.control(""),
      xgroupid: this.fb.control(""),
      placeid: this.fb.control("")
    })
  }

  loadForms() {
    isDebugMode ? console.log(`loadForms()`) : undefined
  }

  selectChange(event) {
    console.log(event)
    this.sessionForm.patchValue(event);
    //this.sessionForm.controls['themeid'].setValue(event.themeid)
    //this.appService.session.themeid = event.themeid
    //this.appService.eventSession.emit(this.appService.session)
  }

  btnCloseMsg() {
    this.modalOpened = false;

    this.appService.readMsg(this.messages).subscribe(
      data => {
        this.messages = []
      }
      , err => {
        console.log(err.error)
      }
    )
  }

  onMsgClick(msgid) {
    console.log(msgid)
  }

  isRead(event) {

    let msg = this.messages.filter(msg => msg.msgid == event)[0]
    msg.checked = true;


  }

  isReadAll( ) {

    console.log(this.msgAll)

    this.messages.forEach(msg => {
      msg.checked = this.msgAll
    })

  }


}
